import React from "react";

import { OrderStatus } from "../../types/order.type";
import { getPaymentStatus } from "../../utils/getPaymentStatus";
import styles from "./styles.module.scss";

interface Props {
  status: string;
}

const PaymentStatusComponent: React.FC<Props> = (props) => {
  const getAccentStyle = () => {
    switch (props.status) {
      case OrderStatus.PAID:
        return styles.paid;
      case OrderStatus.PENDING:
        return styles.prepaid;
      case OrderStatus.PREPARING:
        return styles.preparing;
      case OrderStatus.PACKED:
        return styles.packed;
      case OrderStatus.SHIPPED:
        return styles.shipped;
      case OrderStatus.DELIVERED:
        return styles.delivered;
      case OrderStatus.RECEIVED:
        return styles.received;
      case OrderStatus.CANCELED:
      default:
        return styles.canceled;
    }
  };

  return (
    <div className={`${styles.container} ${getAccentStyle()}`}>
      <span className={`${styles.text} ${getAccentStyle()}`}>
        {getPaymentStatus(props.status)}
      </span>
    </div>
  );
};

export default PaymentStatusComponent;
